import { render, staticRenderFns } from "./SaleUnitItems.vue?vue&type=template&id=0acf587c&scoped=true"
import script from "./SaleUnitItems.vue?vue&type=script&lang=js"
export * from "./SaleUnitItems.vue?vue&type=script&lang=js"
import style0 from "./SaleUnitItems.vue?vue&type=style&index=0&id=0acf587c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf587c",
  null
  
)

export default component.exports